const TYPE = 'REGISTRATION_SET_DEVICE_CONNECTED';

const action = (connected) => (dispatch) => dispatch({ type: TYPE, payload: connected });

export default { action, TYPE };
